import React from 'react';
import { Language } from '../types';
import { Globe } from 'lucide-react';

interface LanguageSelectorProps {
  onSelect: (language: Language) => void;
}

const languages: { id: Language; label: string; native: string }[] = [
  { id: 'english', label: 'English', native: 'English' },
  { id: 'hindi', label: 'Hindi', native: 'हिन्दी' },
  { id: 'kannada', label: 'Kannada', native: 'ಕನ್ನಡ' }
];

export function LanguageSelector({ onSelect }: LanguageSelectorProps) {
  return (
    <div className="fixed inset-0 z-50 bg-gallery-light flex items-center justify-center p-6">
      <div className="w-full max-w-sm">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-full bg-gallery-accent/20 flex items-center justify-center">
            <Globe className="w-8 h-8 text-gallery-accent" />
          </div>
        </div>
        
        {/* Heading */}
        <h2 className="text-xl font-semibold text-center text-gallery-dark mb-2">
          Choose your preferred language
        </h2>
        <p className="text-gray-600 text-center text-sm mb-8">
          for the audio experience
        </p>
        
        {/* Language Options */}
        <div className="space-y-3">
          {languages.map((lang) => (
            <button
              key={lang.id}
              onClick={() => onSelect(lang.id)}
              className="w-full p-4 rounded-xl border border-gray-700 hover:border-gallery-accent 
                         hover:bg-gallery-accent/10 transition-all duration-200 
                         flex items-center justify-between group"
            >
              <span className="text-gallery-dark font-medium group-hover:text-gallery-accent">
                {lang.label}
              </span>
              <span className="text-gray-500 group-hover:text-gallery-accent">
                {lang.native}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
